export enum Roles{
    None=0,User = 1,SuperVisor = 2,Admin = 3
}